import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './useAuth';

interface UseAuthRedirectOptions {
  redirectTo?: string;
  requireAuth?: boolean;
  requiredRole?: string;
}

export const useAuthRedirect = (options: UseAuthRedirectOptions = {}) => {
  const {
    redirectTo = '/dashboard',
    requireAuth = false,
    requiredRole,
  } = options;

  const { isAuthenticated, isLoading, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;

    // Redirect authenticated users away from login/signup pages
    if (!requireAuth && isAuthenticated) {
      navigate(redirectTo, { replace: true });
      return;
    }

    // Redirect unauthenticated users to login
    if (requireAuth && !isAuthenticated) {
      navigate('/login', { replace: true });
      return;
    }

    // Check role-based access
    if (requiredRole && user && !user.groups?.includes(requiredRole)) {
      navigate('/unauthorized', { replace: true });
    }
  }, [isAuthenticated, isLoading, user, navigate, redirectTo, requireAuth, requiredRole]);

  return { isLoading, isAuthenticated, user };
};